import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LabelContext } from "../labels/LabelContext";
import { ResponsiveSize, ValidationState } from "../Types";
import styles from "../inputs/InputBase.scss";

export interface DatePickerProviderProps {
  /**
   * Id of the element.
   */
  id?: string;
  /**
   * Name of the element
   */
  name?: string;
  /**
   * Id of the HTML element describing the input
   */
  describedBy?: string;
  /**
   * Value
   */
  value?: Date;
  /**
   * Element size, e.g. xs, sm, etc.
   */
  size?: ResponsiveSize;
  /**
   * Validation state.
   */
  state?: ValidationState;
  /**
   * Control disabled
   */
  disabled?: boolean;
  /**
   * Custom class
   */
  className?: string;
  /**
   * Placeholder text
   */
  placeholder?: string;
  /**
   * On Change
   * */
  onChange: (date: Date | null) => void;
  /**
   * Min date available
   */
  minDate?: Date;
  /**
   * Max date available
   */
  maxDate?: Date;
}

export const DatePickerProvider: React.FC<DatePickerProviderProps> = ({
  size = "block",
  ...props
}) => {
  const [value, setValue] = useState<Date | null>(null);

  useEffect(() => {
    if (props.value) setValue(props.value);
    else if (value) {
      setValue(null);
    }
  }, [props.value]);

  const onChange = (d: Date | null) => {    
    if(d) d = new Date(d.toDateString());
    setValue(d);
    props.onChange && props.onChange(d);
  };

  const labelCtx = useContext(LabelContext);
  const state = labelCtx.state || props.state;

  return (
    <DatePicker
      id={props.id || labelCtx.id}
      name={props.name}
      selected={value}
      onChange={(date) => onChange(date)}
      minDate={props.minDate}
      maxDate={props.maxDate}
      disabled={props.disabled}
      placeholderText={props.placeholder}
      className={classNames(
        styles["au-text-input"],
        {
          [styles[`au-text-input--${state}`]]: state,
          [styles[`au-text-input--width-${size}`]]: size && size != "block",
          [styles[`au-text-input--block`]]: size == "block",
        },
        props.className
      )}
      dateFormat="dd/MM/yyyy"
      aria-describedby={props.describedBy || labelCtx.describedBy}
    />
  );
};
